import React, { useCallback,useEffect, useState, useContext, useRef ,useMemo} from 'react'
import { useHistory } from 'react-router-dom'
import styles from './edit-order.module.scss'
import { IOrder, IState,IAddress } from 'src/Interface'
import Button from 'src/components//button/Button'
import { StateContext, DispatchContext } from '../../AppContext'
import { parse } from 'date-fns/esm'
import axios from 'axios'
import { baseApiURL } from 'src/utils/utils'
import { add, format } from 'date-fns'
import { toast } from 'react-toastify'
import useCancellablePromise from 'src/utils/useCancellablePromise'
import AutocompletePoi from 'src/components//autocomplete/AutocompletePoi'
import ReactDatePicker from 'react-datepicker'
import DropDown from 'src/components/dropDown/Dropdown'
import TextArea from 'src/components/textArea/TextArea'
import Input from 'src/components//input/Input'
import { isValidNumberForRegion } from 'libphonenumber-js'
import TimeInputComponent from 'src/components/timeInput/TimeInput'
import da from 'date-fns/locale/da'

interface IProps {
  close?: any
  referenceLabel: string
  orderId:number
}

interface IValues {
  numberOfPeople: string
  destinationAddress: IAddress
  pickupAddress: IAddress
  comment: string
  price: string
  tripType: string
  customerName: string
  attributes: Array<any>
  numberOfCars: string
  customerPhone: string
  reference: string
}

const EditOrder: React.FunctionComponent<IProps> = ({ close, referenceLabel, orderId }: IProps) => {
  const dispatch: React.Dispatch<any> = useContext(DispatchContext)
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const state: IState = useContext(StateContext)
  const order: IOrder = state.userOrders.find((o: any) => o.id === Number(orderId))
  const { cancellablePromise } = useCancellablePromise()
  const [errors, setErrors] = useState({})
  const [validationErrors, setValidationErrors] = useState<any>({})
  const [shouldUpdateTime, setShouldUpdateTime] = useState(true)
  const [accountId, setAccountId] = useState('')
  const [time, setTime] = useState(new Date(order.requestedPickup))
  const [accounts, setAccounts] = useState([])
  const [orderPending, setOrderPending] = useState(false)
  const [date, setDate] = useState(new Date(order.requestedPickup))
  const timeInterval = useRef(null)
  const addresses= useMemo(() => state.addresses, [state.addresses])

  const [values, setValues] = useState<IValues>({
    tripType: order.tripType,
    numberOfPeople: order.numberOfPeople?.toString(),
    destinationAddress: order.destinationAddress,
    pickupAddress: order.pickupAddress,
    comment: order.comment,
    price: '',
    attributes: order.attributes.map((attribute)=>attribute.id),
    customerName: order.customerName,
    numberOfCars: '1',
    customerPhone: order.phone,
    reference: order.reference,
  })

  const [bookingModule, setBookingModule] = useState({
    attributes: [],
    fields: [],
    updatedAt: '',
    referenceLabel: ''
  })

  useEffect(() => {
    if (!shouldUpdateTime) {
      clearTimeout(timeInterval.current);
    }
  }, [shouldUpdateTime])


  useEffect(() => {
    setAccountId(order.account?.id? order.account.id : null)

    return () => {
      clearTimeout(timeInterval.current);
    }
  }, [])

  useEffect(() => {
    if (state.user.companyId && state.user.accessToken) {
      cancellablePromise(axios(`${baseApiURL()}/companies/${state.user.companyId}/booking_module`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result) => {
        setValues({...values,
          attributes:result.data.attributesFields.filter(attribute => attribute.required || order.attributes.map((orderAttribute)=>orderAttribute.id).includes(attribute.id) ).map(attribute => attribute.id)})
        setBookingModule({ attributes: result.data.attributesFields, fields: result.data.staticFields, updatedAt: result.data.updatedAt, referenceLabel: result.data.referenceLabel })
      }).catch((err) => {
        toast(err.response.data.message)
        setLoading(false)

      }))
    }
  }, [state.user.accessToken, state.user.companyId, cancellablePromise])

  useEffect(() => {
    if (state.user.accessToken && state.user.branchId && state.user.id) {
      cancellablePromise(axios(`${baseApiURL()}/users/${state.user.id}/accounts`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
        .then((result) => {
          setAccounts([{ label: 'Ingen konto', value: '' }, ...result.data.map(item => ({ label: item.name, value: item.id, defaultAccount: item.defaultAccount }))])
        }).catch((err) => {
          setLoading(false)
          toast(err.response.data.message)
        }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancellablePromise, dispatch, state.user])

  const updateTime = useCallback((date) => {
    clearTimeout(timeInterval.current);
    setTime(date)
    const remainingSeconds = 60 - date.getSeconds()
    timeInterval.current = window.setTimeout(() => updateTime(add(date, { seconds: remainingSeconds })), Number(remainingSeconds + '000'));
  }, [])
 
  const resetError = (fieldName: string) => {
    setErrors({
      ...errors,
      [fieldName]: false
    })
    setValidationErrors({
      ...validationErrors,
      [fieldName]: false
    })
  }

  if (!order) {
    history.push('/order')
    return null
  }

  const clearData = () => {
    setAccountId(order.account?.id?order.account.id : null)
    setValues({
      tripType:'METERED',
      numberOfPeople: order.numberOfPeople?.toString(),
      destinationAddress: order.destinationAddress,
      pickupAddress: order.pickupAddress,
      comment: order.comment,
      price: '',
      attributes: order.attributes.map((attribute)=>attribute.id),
      customerName: order.customerName,
      numberOfCars: '1',
      customerPhone: order.phone,
      reference: order.reference,
    })
  }

  const handleValidation = (regexp: RegExp, fieldName: string) => (value: string) => {
    let error = false

    if (fieldName === 'customerPhone') {
      if (!isValidNumberForRegion(value, 'DK')) {
        error = true
      }
    } else {
      if (value && regexp && !regexp.test(value || '')) {
        error = true
      }
    }
    setValidationErrors({
      ...validationErrors,
      [fieldName]: error
    })
  }
  const handleTimeChange = useCallback((time) => {
    setTime(time)
    setShouldUpdateTime(false)
  }, [])

  const handleDateChange = useCallback((date) => {
    setDate(date)
  }, [])

  const toggleSelectedAddons = (id: number) => {
    if (values.attributes.includes(id)) {
      const attributes = [...values.attributes]
      const index = values.attributes?.findIndex(a => a === id)
      attributes.splice(index, 1)
      setValues({...values,
        attributes:attributes
    })
    } else {
      setValues({...values,
        attributes:[...values.attributes, id]
    })
    }
  }

  const handleInputChange = (fieldName: string) => (value: any) => {
    const valuesObj = { ...values }

    valuesObj[fieldName] = value
    if (fieldName === 'pickupAddress' && value) {
      valuesObj.comment = value.comment
      valuesObj[fieldName].poi =  valuesObj[fieldName].label? valuesObj[fieldName].label: valuesObj[fieldName].poi
    }

    if (fieldName === 'destinationAddress' && value) {
      valuesObj[fieldName].poi =  valuesObj[fieldName].label? valuesObj[fieldName].label: valuesObj[fieldName].poi
    }
    setValues(valuesObj)
  }

  const { detailFields, customerFields, propeties, addons, requiredFields } = useMemo(() => {
    const detailFields = bookingModule.fields.filter((item) => item.category === 'DETAILS')
    const customerFields = bookingModule.fields.filter((item) => item.category === 'CUSTOMER')
    const propeties = bookingModule.attributes.filter(attribute => attribute.required)
    const addons = bookingModule.attributes.filter(attribute => !attribute.required)

    const requiredFields = [...customerFields, ...detailFields].filter(field =>
      field.required &&
      field.code !== 'BE' &&
      field.code !== 'TI' &&
      field.code !== 'DA' &&
      field.code !== 'FI'
    ).map(field => field.code)

    return { detailFields, customerFields, propeties, addons, requiredFields }
  }, [bookingModule.attributes, bookingModule.fields]
  )

  const requiredFieldsLength = requiredFields.filter(code => {
    const fields = [...state.bookingModule.detailFields.list, ...state.bookingModule.customerFields.list]
    const matchedField = fields.find(field => field.code === code)
    return matchedField ? !!values[matchedField.name] : false
  }).length

  const updateOrder = () => {
    if (requiredFieldsLength < requiredFields.length) {
      const errors = {};
      requiredFields.filter(code => {
        const fields = [...state.bookingModule.detailFields.list, ...state.bookingModule.customerFields.list]
        const matchedField = fields.find(field => field.code === code)

        return matchedField ? !values[matchedField.name] : false
      }).forEach(code => {
        errors[code] = true
      })
      setErrors(errors)
    } 
    else if (Number(values.numberOfPeople) > 4) {
      dispatch({
        type: 'SHOW_MODAL',
        modalType: 'bigCarConfirmation',
        showModal: true,
        order: {
          bookingModuleUpdatedAt: bookingModule.updatedAt,
          requestedPickup: parse(`${format(date, 'yyyy-MM-dd')}:${format(time, 'HH:mm')}`, 'yyyy-MM-dd:HH:mm', new Date()).toISOString(),
          attributes: values.attributes,
          ...values
        }
      })
      clearData()
    }
    else {
      setOrderPending(true)
      axios.put(`${baseApiURL()}/orders/${order?.id}`, {
        requestedPickup: parse(`${format(date, 'yyyy-MM-dd')}:${format(time, 'HH:mm')}`, 'yyyy-MM-dd:HH:mm', new Date()).toISOString(),
        pickupAddress: values.pickupAddress,
        destinationAddress: values.destinationAddress,
        attributeIds: values.attributes,
        bookingModuleUpdatedAt: bookingModule.updatedAt,
        tripType: values.tripType,
        numberOfCars: 1,
        numberOfPeople: Number(values.numberOfPeople),
        reference: values.reference ? values.reference : null,
        comment: values.comment ? values.comment : null,
        customerName: values.customerName ? values.customerName : null,
        customerPhone: values.customerPhone ? values.customerPhone : null,
        accountId: accountId,
        fixedTripId:order.fixedTripId
      }, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
        .then((result) => {
          // Update the order in the existing list instead of fetching all orders
          const ordersCopy = [...(Array.isArray(state.userOrders) ? state.userOrders : [])]
          const orderIndex = ordersCopy.findIndex(o => Number(o.id) === Number(orderId))
          if (orderIndex >= 0 && result.data) {
            // Handle both array and single object responses
            const updatedOrder = Array.isArray(result.data) ? result.data[0] : result.data
            if (updatedOrder) {
              ordersCopy.splice(orderIndex, 1, updatedOrder)
              dispatch({ type: 'SET_USER_ORDERS', userOrders: ordersCopy })
            }
          }
          clearData()
          close()
          setOrderPending(false)
        }).catch((err) => {
          setOrderPending(false)
          setLoading(false)
          if (err.response.data.code === 4020) {
            toast('Bookingmodulet er blevet opdateret. Venligst indlæs siden igen')
          } else {
            toast(err.response.data.message)
          }
       })
    }
  }

  return (
    <div className='tw-relative tw-flex tw-flex-col tw-flex-auto'>
      <header className={styles.header}>
        <h4>Opdater ordre</h4>
        <span className={styles.closeIcon} onClick={close}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </span>
      </header>
      <main className={styles.container}>
        <div className={styles.order} >
        {propeties.length > 0 ? <div className={styles.attributes}>
            {!loading && <ul className='tw-flex tw-flex-auto tw-items-center tw-flex-wrap'>
              {propeties.filter(item => item.required)
                .map((item, index) =>
                  <li className={styles.attributeItem} key={index}>
                    <span className='tw-w-4 tw-h-4 tw-mr-2'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    </span>
                    <span>{item.description}</span>
                  </li>)}
            </ul>}
          </div> : null}
          <div className={styles.content}>
            {loading ?
              <div className='animate-pulse'>
                <div className={styles.section}>
                  <div className='tw-flex-1 tw-mr-4 input-field-loading' />
                  <div className='tw-flex-1 tw-mr-4 input-field-loading' />
                  <div className='tw-flex-2 input-field-loading' />
                </div>
                <div className={styles.section}>
                  <div className='tw-flex-full tw-mb-9 input-field-loading' />
                  <div className='tw-flex-full input-field-loading' />
                </div>
                <div className={styles.section}>
                  <div className='label-loading label-loading--small tw-mb-2' />
                  <div className='tw-flex tw-flex-wrap tw-flex-full'>
                    <div className={`tw-flex-2 tw-mr-4 input-field-loading`} />
                    <div className={`tw-flex-2 tw-mr-4 input-field-loading`} />
                  </div>
                  <div className='tw-flex-1' />
                </div>
                <div className={styles.section}>
                  <div className='label-loading label-loading--small tw-mb-5' />
                  <div className='tw-flex tw-flex-wrap tw-flex-full tw-mb-8'>
                    <div className={`tw-flex-2 tw-mr-4 input-field-loading`} />
                    <div className={`tw-flex-2 tw-mr-4 input-field-loading`} />
                  </div>
                  <div className='tw-flex tw-flex-wrap tw-flex-full tw-mb-8'>
                    <div className={`tw-flex-2 tw-mr-4 input-field-loading`} />
                    <div className={`tw-flex-2 tw-mr-4 input-field-loading`} />
                  </div>
                  <div className='tw-flex tw-flex-wrap tw-flex-full'>
                    <div className={`tw-flex-2 tw-mr-4 input-field-loading`} />
                    <div className={`tw-flex-2 tw-mr-4 input-field-loading`} />
                  </div>
                </div>
              </div> : <>
                <div className={styles.section}>
                  {state.bookingModule.detailFields.list.filter((propety) => detailFields.find((item) => propety.code === item.code))
                    .map((item, index) => {
                      switch (item.type) {
                        case 'autocomplete':
                          return <div key={index} className={`tw-mb-5 ${item.modifier ? item.modifier : ''} `}>
                            <AutocompletePoi
                              readOnly={values.tripType==='FIXED'}
                              completedAddress={values[item.name]}
                              predefinedAddresses={addresses}
                              error={errors[item.code]}
                              resetError={() => resetError(item.code)}
                              label={`${item.inputLabel || item.description}${(detailFields.find((field) => field.code === item.code).required || (values.tripType==='FIXED' || Number(values.numberOfPeople) > 4)) ? '*' : ''}`}
                              placeholder={item.placeholder}
                              iconType={item.name === 'pickupAddress' ? 'pickup' : 'destination'}
                              setAddress={() => handleInputChange(item.name)}
                              name={item.name} />
                            {errors[item.code] && <p className='errorMsg'>Mangler at udfylde {(item.inputLabel || item.description).toLocaleLowerCase()}</p>}

                          </div>
                        case 'dropdownInput':
                          {
                            if(item.name==='numberOfPeople')
                            {
                             return <div key={index} className={`${item.modifier ? item.modifier : ''} `}> 
                                <DropDown
                                  readOnly={true}
                                  value={values[item.name] ? Number(values[item.name]) : 4}
                                  label={`${item.inputLabel || item.description}${detailFields.find((field) => field.code === item.code).required ? '*' : ''}`}
                                  modifiers='tw-flex-full tw-mb-5'
                                  options={item.dropDownOptions}
                                  handleOnChange={() => handleInputChange(item.name)}/>
                              </div>
                            }
                          }
                        case 'date':
                          return (
                            <div key={index} className={`tw-mb-3 tw-mr-3 last:mr-0 ${item.modifier ? item.modifier : ''} `}>
                              <label htmlFor='datePicker' className={styles.inputLabel}>{` ${item.inputLabel || item.description} ${detailFields.find((field) => field.code === item.code).required ? '*' : ''}`}</label>
                              <ReactDatePicker
                                selected={date}
                                id='datePicker'
                                minDate={new Date()}
                                locale={da}
                                dateFormat="dd/MM/yyyy"
                                className={styles.datePicker}
                                onChange={handleDateChange}
                              />
                              {errors[item.code] && <p className='errorMsg'>Mangler at udfylde {(item.inputLabel || item.description).toLocaleLowerCase()}</p>}
                            </div>)
                        case 'time':
                          return <div key={index} className={`tw-mb-3 tw-mr-3 last:mr-0 ${item.modifier ? item.modifier : ''} `}>
                            <TimeInputComponent
                              value={time}
                              handleChange={handleTimeChange}
                              label={`
                         ${item.inputLabel || item.description}
                          ${detailFields.find((field) => field.code === item.code).required ? '*' : ''}`} />
                            {errors[item.code] && <p className='errorMsg'>Mangler at udfylde {(item.inputLabel || item.description).toLocaleLowerCase()}</p>}
                          </div>
                        default:
                          return <div key={index} className={`tw-mb-3 tw-mr-3 last:mr-0 ${item.modifier ? item.modifier : ''} `}>
                            <Input
                              placeholder={item.placeholder}
                              type={item.type}
                              value={order[item.name]}
                              handleValidation={() => handleValidation(item.validation, item.name)}
                              error={validationErrors[item.name]}
                              readOnly={true}
                              min={format(new Date(), item.type === 'date' ? 'yyyy-MM-dd' : 'HH:mm')}
                              handleInputChange={() => handleInputChange(item.name)}
                              IconRight={item.IconRight}
                              countryCode={item.countryCode}
                              label={`${item.inputLabel || item.description}
                              ${detailFields.find((field) => field.code === item.code).required ? '*' : ''}`}
                              name='' />
                            {errors[item.code] && <p className='errorMsg'>Mangler at udfylde {(item.inputLabel || item.description).toLocaleLowerCase()}</p>}
                          </div>
                      }
                    })}
                  {(values.tripType==='FIXED' || Number(values.numberOfPeople) > 4) && !detailFields.find((item) => 'DE' === item.code) && <AutocompletePoi
                    label='Destination *'
                    placeholder='Vælg destination'
                    iconType='destination'
                    readOnly={values.tripType==='FIXED'}
                    modifiers='tw-mb-5 tw-flex-full'
                    setAddress={() => handleInputChange('destinationAddress')}
                    completedAddress={values.destinationAddress}
                    name='destinationAddress'
                  />}
                </div>
                {addons && addons.length > 0 && <div className={styles.section}>
                  <h6 className='tw-flex-full tw-mb-3'>Tilvalg</h6>
                  {addons.map((item, index) => (
                    <Button
                      modifiers='tw-mr-3 first:ml-0 tw-mb-3'
                      disabled={values.tripType==='FIXED'}
                      handleClick={() => toggleSelectedAddons(item.id)}
                      label={item.description}
                      type={(values.attributes && values.attributes.find((attribute: any) => attribute === item.id) ? 'addonActive' :  'addon')}
                      key={index} />
                  ))}
                </div>
                }
                 <div className={styles.section}>
                  <h6 className='tw-flex-full tw-mb-3'>Kunde informationer</h6>
                  {accounts && accounts.length > 1 &&
                    <DropDown
                      placeholder='Vælg konto'
                      value={accountId}
                      label='Konto'
                      modifiers='tw-flex-full tw-mb-5'
                      options={accounts}
                      handleOnChange={setAccountId}
                    />}
                  {state.bookingModule.customerFields.list.filter((propety) => customerFields.find((item) => propety.code === item.code))
                    .map((item, index) => {
                      if (item.type === 'dropdown') {
                        return <div key={index} className={`tw-mb-5 tw-mr-3 last:mr-0 ${item.modifier ? item.modifier : ''} `}>
                          <DropDown
                            key={index}
                            label={item.inputLabel || item.description}
                            curried={true}
                            value={accountId ? 'card' : 'cash'}
                            options={item.dropDownOptions}
                          />
                          {errors[item.code] && <p className='errorMsg'>Mangler at udfylde {(item.inputLabel || item.description).toLocaleLowerCase()}</p>}

                        </div>
                      } else if (item.type === 'textarea') {
                        return <div key={index} className={`tw-mb-5 tw-mr-3 last:mr-0 ${item.modifier ? item.modifier : ''} `}>
                          <TextArea
                            name='test'
                            resetError={() => resetError(item.code)}
                            error={errors[item.code]}
                            label={`${item.inputLabel || item.description} ${customerFields.find((field) => field.code === item.code).required ? '*' : ''} `}
                            handleInputChange={() => handleInputChange(item.name)}
                            value={values.comment}
                            placeholder={item.placeholder}
                          />
                          {errors[item.code] && <p className='errorMsg'>Mangler at udfylde {(item.inputLabel || item.description).toLocaleLowerCase()}</p>}
                        </div>
                      }
                      return <div key={index} className={`tw-mr-3 tw-mb-3 ${item.modifier ? item.modifier : ''} `}>
                        <Input
                          placeholder={item.placeholder}
                          key={index}
                          type='text'
                          isAllowOnlyDigits={item.name ==='customerPhone'}
                          value={values[item.name]}
                          handleValidation={() => handleValidation(item.validation, item.name)}
                          error={validationErrors[item.name] || errors[item.code]}
                          handleInputChange={() => handleInputChange(item.name)}
                          IconRight={item.IconRight}
                          countryCode={item.countryCode}
                          resetError={() => resetError(item.code)}
                          label={`${item.code === 'RE' ? bookingModule.referenceLabel : item.inputLabel || item.description}
                          ${customerFields.find((field) => field.code === item.code).required ? '*' : ''} `}
                          name={item.name} />
                        {errors[item.code] && <p className='errorMsg'>Mangler at udfylde {(item.inputLabel || item.description).toLocaleLowerCase()}</p>}
                        {validationErrors.customerPhone && item.name === 'customerPhone' && <p className='errorMsg'>Ugyldigt telefonnummer</p>}
                      </div>
                    })}
                </div>
              </>}
          </div>
        
        </div>
      </main>
      <footer className={styles.footer}>
        <Button loading={orderPending || loading} modifiers={state.company.id === state.user.companyId ? 'tw-ml-auto' : ''}  type='primary' label='Gem ændringer' handleClick={updateOrder} />
      </footer>
    </div>
  )
}

export default EditOrder
